import { useEffect } from 'react';

/**
 * Багц бараа үүсгэх урсгалын хагас дутуу мэдээллийг (draft) хадгалах.
 *
 * Бүх төлөв нь React context/state-д байдаг тул хуудсаа refresh хийхэд бөглөсөн
 * мэдээлэл алга болдог байсан. sessionStorage-д хадгалснаар refresh хийсэн ч
 * бөглөсөн талбар, зураг, сонгосон дэд бараанууд, тоо ширхэг нь сэргэнэ.
 *
 * ХАМРАХ ХҮРЭЭ: draft нь ЗӨВХӨН тухайн хуудас дээр байх хугацаанд л хүчинтэй.
 * Өөр хуудас руу орвол `useClearDraftOnLeave` шууд цэвэрлэдэг тул дараа дахин
 * орж ирэхэд форм хоосон эхэлнэ (доорх hook-ийг үзнэ үү).
 *
 * sessionStorage-ыг сонгосон шалтгаан: таб хаагдахад өөрөө цэвэрлэгдэнэ,
 * өөр таб дээрх шинэ багцад хөндлөнгөөс оролцохгүй.
 *
 * `ProductProvider`-т key дамжуулаагүй бол draft бүрэн унтарна.
 *
 * Нэгж бараа (views/product/draft.js), хүргэлт (views/orderDelivery/Add/draft.js),
 * буцаалт (views/orderReturn/Add/draft.js), татан авалт (views/orders/draft.js)
 * дээр ижил механизм байгаа — зан төлөвийг өөрчлөх бол бүгдийг харна.
 */
export const GROUP_PRODUCT_DRAFT_KEY = 'add_group_product_draft';

/**
 * Draft-ын key-г merchant тус бүрд салгана.
 *
 * `changeMerchant` (store/createUserSlice.js) нь merchant солиход
 * `window.location.href`-ээр НЭГ ЛЭ таб дотор дахин уншуулдаг тул sessionStorage
 * хэвээрээ үлддэг. Key нь тогтмол байсан бол өмнөх merchant дээр сонгосон дэд
 * бараанууд шинэ merchant-ийн формд сэргэх байсан.
 */
export const groupProductDraftKey = (merchantCode) =>
  merchantCode ? `${GROUP_PRODUCT_DRAFT_KEY}_${merchantCode}` : GROUP_PRODUCT_DRAFT_KEY;

export const readDraft = (key) => {
  if (!key) return {};

  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.error('readDraft error: ', error);
    return {};
  }
};

export const writeDraft = (key, draft) => {
  if (!key) return;

  try {
    sessionStorage.setItem(key, JSON.stringify(draft));
  } catch (error) {
    // Хэмжээ хэтэрсэн зэрэг тохиолдолд урсгалыг тасалдуулахгүй
    console.error('writeDraft error: ', error);
  }
};

/** Багц амжилттай үүссэний дараа дуудаж draft-ыг цэвэрлэнэ */
export const clearDraft = (key) => {
  if (!key) return;

  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error('clearDraft error: ', error);
  }
};

/**
 * Хуудсаас гармагц draft-ыг цэвэрлэнэ.
 *
 * Багц үүсгэх хуудас unmount болох (өөр хуудас руу орох, толгойн "back",
 * breadcrumb, "Болих", хажуугийн меню, browser-ийн back — бүгд) үед л cleanup
 * ажиллана. Тиймээс хагас бөглөсөн мэдээлэл дараа хуудсанд дахин орж ирэхэд
 * сэргэхгүй.
 *
 * Refresh дээр ХАМААРАХГҮЙ: хуудас дахин уншихад JS бүхэлдээ унтардаг тул
 * React cleanup ажиллаж чаддаггүй — refresh-ийн сэргээлт хэвээрээ.
 *
 * `key` нь merchant-аар өөрчлөгддөг (`groupProductDraftKey`) тул merchant
 * солиход өмнөх merchant-ийн draft мөн адил цэвэрлэгдэнэ.
 */
export const useClearDraftOnLeave = (key) => {
  useEffect(() => () => clearDraft(key), [key]);
};
